module.exports = __webpack_public_path__ + "static/img/11.ecb9527.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/11.png
// module id = 3QeZ
// module chunks = 0